import React from 'react';
import * as Devices from '../../modules/devices';
import * as Register from '../../modules/dialogs/register';
import { RegisterDevice } from '../../modules/dialogs/register';
import SVGIcon, { SVGIcons } from '../shared/svgIcon';
import Translate from '../shared/localization/localize';
import LinkText from '../shared/linkText';

const Item = (device: RegisterDevice): JSX.Element => {
  const pkey = Devices.getPK(device);
  const id = `dg-register-list-item-${pkey}-${device.code}`;
  const contentClassName =
    String(device.errorMsg) === ''
      ? 'item_content'
      : 'item_content item_content_witherrors';
  return (
    <div id={id} key={id} className="register_item">
      <div className={contentClassName}>
        <span className="icon">
          <SVGIcon name={SVGIcons.Flag} fill="red" width="100%" height="100%" />
        </span>

        <div className="info">
          <span className="title">
            {pkey}/{device.code}
          </span>
          <div className="subtitle">
            <Translate message={device.errorMsg} />
          </div>
        </div>
      </div>
      <LinkText
        onClick={() => Register.clearDevice(device)}
        className="item_clear"
        content={<SVGIcon name={SVGIcons.Dismiss} />}
      />
    </div>
  );
};

type Props = {
  devices: Register.RegisterDevice[];
};

const RegisterList: React.FC<Props> = (props) => {
  return (
    <div className="register_list">
      {props.devices.map((rd) => (
        <Item key={`regitem-${Devices.getPK(rd)}`} {...rd} />
      ))}
    </div>
  );
};

export default RegisterList;
